import { HomeRepository } from '../../domain/interfaces/HomeRepository';
import { HomePageData } from '../../domain/models/HomePageData';

// Type for the service returned by createHomeService
export type HomeService = ReturnType<typeof createHomeService>;

export function createHomeService(repo: HomeRepository) {
  return {
    async getHomePageData(): Promise<HomePageData> {
      const data = await repo.fetchHomePageData();
      return data;
    }
  };
}

